import { CommonError } from '../../types';
import { ContestActions } from './actions';
import { 
    FETCH_ONGOING_CONTEST_FAILURE, 
    FETCH_ONGOING_CONTEST_REQUEST, 
    FETCH_ONGOING_CONTEST_SUCCESS,
    FETCH_CONTEST_DETAIL_FAILURE,
    FETCH_CONTEST_DETAIL_REQUEST,
    FETCH_CONTEST_DETAIL_SUCCESS
} from './constants';
import { Contest } from './types';

export interface ContestState {
    ongoingContest: Contest;
    contestDetail: Contest | null;
    loading: boolean;
    error: CommonError | null;
}

const initialState: ContestState = {
    ongoingContest: {
        contestId: null,
        contestName: '',
        startDateTime: new Date(),
        endDateTime: new Date(),
        banner: '',
        maxParticipants: 0,
    },
    contestDetail: null,
    loading: false,
    error: null, 
};

export const contestReducer = (state = initialState, action: ContestActions): ContestState => {
    switch (action.type) {
        case FETCH_ONGOING_CONTEST_REQUEST:
            return { ...state, loading: true, error: null };
             
        case FETCH_ONGOING_CONTEST_SUCCESS:
            return { 
                ...state, 
                loading: false, 
                ongoingContest: { ...action.payload } 
            };

        case FETCH_ONGOING_CONTEST_FAILURE:
            return { ...state, loading: false, error: null };
            
        case FETCH_CONTEST_DETAIL_REQUEST:
            return { ...state, loading: true, error: null, contestDetail: null };
            
        case FETCH_CONTEST_DETAIL_SUCCESS:
            return { 
                ...state, 
                loading: false, 
                contestDetail: { ...action.payload } 
            };

        case FETCH_CONTEST_DETAIL_FAILURE:
            return { ...state, loading: false, error: action.payload };
            
        default:
            return state;
    }
};
